import { connect } from 'react-redux';
import { decorateWith, withName } from 'helpers/decorator';
import { toggleMapView, selectMapView } from 'features/Search/Search.reducer';
import { ViewToggler } from './ViewToggler';

export const mapStateToProps = state => {
  return {
    isMapView: selectMapView(state),
  };
};

const mapDispatchToProps = {
  onToggleMapView: toggleMapView,
};

export const ViewTogglerContainer = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('ViewTogglerContainer')
)(ViewToggler);
